import React from "react";
import SendIcon from "../../assets/svg/sendIcon.svg";
import { Link } from "react-router-dom";
import { useAuthStore } from "../../redux/features/authSlice";
const Default = () => {
  const { loginInfo } = useAuthStore();
  return (
    <div className="relative min-h-screen pb-32">
      <div className="container mx-auto max-w-9xl min-h-[calc(100vh-8rem)] flex items-center justify-center">
        <div className="w-full">
          <h1 className="gradient-text text-5xl font-bold">
            Hi {loginInfo?.user?.fullname}, <br /> I am your AI assistance!  
          </h1>

          <h4 className="text-xl text-[#5D5D5D] font-semibold mt-4">
            Let's understand your search requirement.
          </h4>

          <div className="grid grid-cols-12 gap-4 mt-10">
            <div className="col-span-6 md:col-span-3">
              <div className="border lg:min-h-[180px] min-h-[200px] flex flex-col justify-between border-[#D4D4D4] rounded-[20px] p-5">
                <h5 className="text-[#5D5D5D] text-lg font-medium">
                  What kind of office space are you looking for?
                </h5>

                <i class="fi fi-rr-building text-[#F8814C] text-3xl "></i>
              </div>
            </div>

            <div className="col-span-6 md:col-span-3">
              <div className="border lg:min-h-[180px] min-h-[200px] flex flex-col justify-between border-[#D4D4D4] rounded-[20px] p-5">
                <h5 className="text-[#5D5D5D] text-lg font-medium">
                  How big of a space do you need?
                </h5>

                <i class="fi fi-tr-ruler-combined text-[#D38ACD] text-3xl "></i>
              </div>
            </div>

            <div className="col-span-6 md:col-span-3">
              <div className="border lg:min-h-[180px] min-h-[200px] flex flex-col justify-between border-[#D4D4D4] rounded-[20px] p-5">
                <h5 className="text-[#5D5D5D] text-lg font-medium">
                  What’s your budget range?
                </h5>

                <i class="fi fi-rr-sack-dollar text-[#00AF50] text-3xl "></i>
              </div>
            </div>

            <div className="col-span-6 md:col-span-3">
              <div className="border lg:min-h-[180px] min-h-[200px] flex flex-col justify-between border-[#D4D4D4] rounded-[20px] p-5">
                <h5 className="text-[#5D5D5D] text-lg font-medium">
                  Do you need any must-have amenities?
                </h5>

                <i class="fi fi-rr-settings text-[#6273FA] text-3xl"></i>
                {/* <i class="fi fi-tc-settings text-[#6273FA] text-3xl "></i> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixed bottom-0 left-0 right-0 bg-white p-4">
        <div className="container mx-auto max-w-7xl">
          <div className="relative">
            <input
              type="text"
              className="w-full border border-[#DEDEDE] bg-[#F4F4F4] pr-14 text-base focus:outline-none rounded-[96px] p-3"
              placeholder="Tell me about your dream office"
            />

            <Link to="/ai-chat">
              <button className="absolute top-[5px] right-2 bg-red-600 rounded-full">
                <img src={SendIcon} alt="" className="w-[40px] h-[40px]" />
              </button>
            </Link>
          </div>

          <p className="text-[#5D5D5D] text-sm mt-2 text-center">
            Our AI Assistant provides smart suggestions, but please verify
            important details before making a decision.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Default;
